import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom'
// import './fonts/Brandon_reg.otf'
import './fonts/Brandon_med.otf'
import './fonts/Brandon_bld.otf'
import './fonts/Brandon_reg.otf'

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root')
);


